import TabPane from '../tabs/src/tab-pane.vue';

/* istanbul ignore next */
TabPane.install = function(Vue) {
  Vue.component(TabPane.name, TabPane);
};

export default TabPane;



// WEBPACK FOOTER //
// ./src/components/element/packages/tab-pane/index.js